import { render, staticRenderFns } from "./UnsplashTab.htm?vue&type=template&id=29afbfbf&scoped=true&"
import script from "./UnsplashTab.js?vue&type=script&lang=js&"
export * from "./UnsplashTab.js?vue&type=script&lang=js&"
import style0 from "./UnsplashTab.scss?vue&type=style&index=0&id=29afbfbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29afbfbf",
  null
  
)

export default component.exports